import { render, staticRenderFns } from "./FormLearnMore.vue?vue&type=template&id=2214a1d4&scoped=true&"
import script from "./FormLearnMore.vue?vue&type=script&lang=js&"
export * from "./FormLearnMore.vue?vue&type=script&lang=js&"
import style0 from "./FormLearnMore.vue?vue&type=style&index=0&id=2214a1d4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214a1d4",
  null
  
)

export default component.exports